/**
 * Styled Components - Created by david on 12/04/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import { BLUE, GRAY_DARK, RED_WARNING } from '../../../theme/colors'
import Icon from 'antd/lib/icon'

interface TitleProps {
  align: string
}

interface InputProps {
  badInput?: boolean
}

interface AlignProps {
  align?: string
  componentWidth?: string
}

export const Container = styled.div`
  background-color: #222;
`

export const Text = styled.div`
  color: #fff;
`

export const StyledInput = styled(Input)`
  border-radius: 0;
  width: 55px;
  background: ${({ badInput }: InputProps) => badInput ? RED_WARNING : 'none'};
`

export const Title = styled.div`
  width: 58px;
  color: #5f6062;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 23px;
  text-align: ${({ align }: TitleProps) => (align ? align : 'center')};
`
export const Align = styled.div`
  user-select: none;
  width: ${({ componentWidth }: AlignProps) =>
    componentWidth ? componentWidth : 'auto'};
  text-align: ${({ align }: AlignProps) => (align ? align : 'center')};
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const WarningIcon = styled(Icon)``

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/LockerTable/ProductRow/styledComponents.tsx